jQuery(function() {
	jQuery('[data-video-box]').each(function() {
		var wind = jQuery(window);
		var element = jQuery(this);
		var container = element.parent();
		var box = jQuery('#'+element.attr('data-video-box')).appendTo(document.body).hide();
		var lightbox = container.parent().find('.lightbox');
		var player_element = box.find('.scs-media-player');
		var player = player_element.mediaPlayer();
		element.find('a.VideoLink, a.roundarrow').on('click', function() {
			lightbox.show();
			var width = parseInt(player_element.css('width'), 10) || 400;
			var height = parseInt(player_element.css('height'), 10) || (width*3/4);
			var padding = 2 * 44;
			box.css({left: (wind.width() - width - padding)/2 + "px", top: (wind.height() - height - padding)/2 + wind.scrollTop() + "px"}).show();
			player_element.css({width: width+'px', height: height+'px'});
			container.addClass("openvideo");
			player.callbacks.playPause(true);
			player.controller.recalc();
			return false;
		});
		lightbox.add(box.find('.closeme')).on('click', function() {
			player.callbacks.playPause(false);
			lightbox.hide();box.hide();
			container.removeClass("openvideo");
			return false;
		});
	});
});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/videoteasercomp.js
// module id = 110
// module chunks = 0